import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { useMorningAuthStore } from "../../store/useMorningAuthStore";
import { enum_api_uri } from "../utils/enum";

export interface TrackingRequest {
    print_number?: number;
    chk_bl_no?: string[];
    bl_no?: string;
    o_kind?: string;
    s_date?: string;
    e_date?: string;
    s_kind?: string;
    s_a_name?: string;
    s_b_contact?: string;
    s_p_dept?: string;
    flag?: string;
}

export interface TrackingResponse {
    접수일자: string;
    B_L번호: string;
    운송장번호: string;
    담당자명: string;
    요청사항: string;
    센터코드: string;
    센터명: string;
    운임: string;
    수량: string;
    보내는상호: string;
    보내는전화번호: string;
    보내는핸드폰번호: string;
    보내는주소1: string;
    보내는주소2: string;
    보내는담당자: string;
    받는상호: string;
    받는전화번호: string;
    받는핸드폰번호: string;
    받는주소1: string;
    받는주소2: string;
    받는담당자: string;
    QR100x100: string;
    QR66x66: string;
}

interface ApiErrorResponse {
    statusCode: number;
    message: string;
}

export const usePostTrackingPopPrint = (
    linkPrint: boolean = false,
    successCallback?: (data: TrackingResponse) => void,
): UseMutationResult<TrackingResponse, AxiosError<ApiErrorResponse>, TrackingRequest> => {
    const accessToken = useMorningAuthStore(state => state.accessToken);

    return useMutation<TrackingResponse, AxiosError<ApiErrorResponse>, TrackingRequest>({
        mutationFn: async requestData => {
            const { chk_bl_no, ...rest } = requestData;
            const payload = {
                ...rest,
                ...(chk_bl_no && chk_bl_no.length > 0 ? { chk_bl_no } : {}),
            };

            const url = linkPrint ? enum_api_uri.tracking_link_print : enum_api_uri.tracking_pop_print;

            const response = await axios.post(url, payload, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
            });
            return response.data.data;
        },

        onSuccess: data => {
            successCallback?.(data);
        },
    });
};
